export default {
    meta: {
        title: '节假日',
        isShowNav: true,
    },
};
